import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"

export function getUser() {
    const page = usePage()
    const user = computed(() => page.props.auth.user)
    
    return user;
}

export function isDealer() {
    const page = usePage()
    const isDealer = computed(() => page.props.auth.is_dealer);
    
    return isDealer == true;
}

export function hasPermission(permission) {
    const page = usePage();
    if (permission == 'dashboard') return true;
    if (page.props.auth.is_dealer) return false;

    return page.props.auth.permissions.includes(permission) || page.props.auth.is_admin;
}